export const bookThemes = {}
export const fontSize = {}

bookThemes.white = {
    body: {
        'background-color': '#ededed',
        'color': "#121214" 
    },
    'div.box': {
        'background-color': '#ededed',
        'color': "#121214"
    },
    h1: {
        'color': '#121214'
    },
    h2: {
        'color': '#121214'
    },
    h3: {
        'color': '#121214'
    },
    h4: {
        'color': '#121214'
    },
    h5: {
        'color': '#121214'
    },
    h6: {
        'color': '#121214'
    },
    text: {
        'color': '#121214'
    },
    p: {
        'color': '#121214'
    },
    span: {
        'color': '#121214'
    },
    label: {
        'color': '#121214'
    },
    a: {
        'color': '#1400ff'
    }
}

bookThemes.dark = {
    body: {
        'background-color': '#121214',
        'color': "#ededed"
    },
    'div.box': {
        'background-color': '#121214',
        'color': "#ededed"
    },
    h1: {
        'color': '#ededed'
    },
    h2: {
        'color': '#ededed'
    },
    h3: {
        'color': '#ededed'
    },
    h4: {
        'color': '#ededed'
    },
    h5: {
        'color': '#ededed'
    },
    h6: {
        'color': '#ededed'
    },
    text: {
        'color': '#ededed'
    },
    p: {
        'color': '#ededed'
    },
    span: {
        'color': '#ededed'
    },
    label: {
        'color': '#ededed'
    },
    a: {
        'color': '#ffc000'
    }
}

bookThemes.sepia = {
    body: {
        'background-color': '#FFFFE0',
        'color': "#704214"
    },
    'div.box': {
        'background-color': '#FFFFE0',
        'color': "#704214"
    },
    h1: {
        'color': '#704214'
    },
    h2: {
        'color': '#704214'
    },
    h3: {
        'color': '#704214'
    },
    h4: {
        'color': '#704214'
    },
    h5: {
        'color': '#704214'
    },
    h6: {
        'color': '#704214'
    },
    text: {
        'color': '#704214'
    },
    p: {
        'color': '#704214'
    },
    span: {
        'color': '#704214'
    },
    label: {
        'color': '#704214'
    },
    a: {
        'color': '#94AA70'
    }
}